<template>
  <div>
    <div class="d-flex align-center flex-wrap mb-3">
      <v-text-field v-model="search" prepend-inner-icon="search" label="Buscar descripción, número, importe..." dense hide-details clearable class="search mr-4"></v-text-field>
      <v-chip-group v-model="filter" mandatory active-class="primary--text">
        <v-chip value="all" small>Todos</v-chip>
        <v-chip value="auto" small><v-icon x-small left>bolt</v-icon>Automáticos</v-chip>
        <v-chip value="manual" small><v-icon x-small left>pan_tool</v-icon>Manuales</v-chip>
      </v-chip-group>
      <v-spacer></v-spacer>
      <v-btn small color="blue-grey" dark @click="$emit('export', 'conciliados')"><v-icon left>download</v-icon> Exportar</v-btn>
    </div>

    <v-data-table
      :headers="headers"
      :items="filtered"
      item-key="id"
      hide-default-header
      :options="{ itemsPerPage: 15 }"
      :footer-props="{ itemsPerPageOptions: [5, 10, 15, 50, -1] }"
      no-data-text="Todavía no hay movimientos conciliados"
      class="conciliados"
    >
      <template v-slot:header>
        <thead>
          <tr class="group-row">
            <th colspan="3" class="sc sc-first sc-last box-title">
              <v-icon small color="primary" class="mr-1">dns</v-icon> Syscore
            </th>
            <th class="gap gap-mid"></th>
            <th colspan="3" class="bk bk-first bk-last box-title">
              <v-icon small color="green darken-2" class="mr-1">account_balance</v-icon> Banco (extracto)
            </th>
            <th class="gap gap-sm"></th>
            <th></th>
          </tr>
          <tr class="col-row">
            <th class="sc sc-first">Fecha</th>
            <th class="sc">Movimiento</th>
            <th class="sc sc-last text-right">Importe</th>
            <th class="gap gap-mid"></th>
            <th class="bk bk-first">Fecha</th>
            <th class="bk">Movimiento</th>
            <th class="bk bk-last text-right">Importe</th>
            <th class="gap gap-sm"></th>
            <th class="action-col"></th>
          </tr>
        </thead>
      </template>

      <template v-slot:item="{ item }">
        <tr>
          <td class="sc sc-first cell-list date-col">
            <div v-for="d in item.details" :key="'d' + d.id" class="cell-row">{{ formatUtils.formatDateString(d.date) }}</div>
          </td>
          <td class="sc cell-list syscore-mov">
            <div v-for="d in item.details" :key="'dm' + d.id" class="cell-row">
              <div>{{ d.tipo }} · {{ d.comprobante }}</div>
              <div class="caption grey--text text--darken-1">{{ d.tercero || d.description || "" }}</div>
            </div>
          </td>
          <td class="sc sc-last cell-list text-right amount-col">
            <div v-for="d in item.details" :key="'da' + d.id" class="cell-row" :class="d.amount < 0 ? 'error--text' : ''">
              {{ formatUtils.formatMoney(d.amount) }}
            </div>
          </td>
          <td class="gap gap-mid text-center">
            <v-icon color="success">
              {{ item.lineas.length > 1 || item.details.length > 1 ? "call_split" : "sync_alt" }}
            </v-icon>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-chip v-on="on" x-small class="mt-1" :color="typeColor(item.type)" :text-color="typeTextColor(item.type)">
                  <v-icon x-small left>{{ typeIcon(item.type) }}</v-icon>{{ typeShortLabel(item) }}
                </v-chip>
              </template>
              <span>{{ typeHint(item) }}</span>
            </v-tooltip>
          </td>
          <td class="bk bk-first cell-list date-col">
            <div v-for="l in item.lineas" :key="'l' + l.id" class="cell-row">{{ formatUtils.formatDateString(l.date) }}</div>
            <div v-if="!item.lineas.length" class="cell-row grey--text caption">—</div>
          </td>
          <td class="bk cell-list bank-mov">
            <div v-for="l in item.lineas" :key="'lc' + l.id" class="cell-row">
              <div>{{ l.concept }}</div>
              <div class="caption grey--text text--darken-1 reference" :title="l.reference || ''">{{ l.reference || "" }}</div>
            </div>
            <div v-if="!item.lineas.length" class="cell-row grey--text caption">Compensado en Syscore (sin movimiento del banco)</div>
          </td>
          <td class="bk bk-last cell-list text-right amount-col">
            <div v-for="l in item.lineas" :key="'la' + l.id" class="cell-row" :class="l.amount < 0 ? 'error--text' : ''">
              {{ formatUtils.formatMoney(l.amount) }}
            </div>
          </td>
          <td class="gap gap-sm"></td>
          <td class="action-col text-center">
            <v-tooltip bottom v-if="editable">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon small color="error" @click="$emit('unmatch', item)">
                  <v-icon small>link_off</v-icon>
                </v-btn>
              </template>
              <span>Desconciliar</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { formatUtils } from "@/libs/utils/formatUtils";

export default {
  props: {
    matches: { type: Array, default: () => [] },
    editable: Boolean,
  },
  data() {
    return {
      formatUtils,
      search: "",
      filter: "all",
      headers: [
        { text: "Fecha", value: "", sortable: false },
        { text: "Movimiento Syscore", value: "", sortable: false },
        { text: "Importe", value: "", sortable: false, align: "right" },
        { text: "", value: "", sortable: false },
        { text: "Fecha", value: "", sortable: false },
        { text: "Movimiento Banco", value: "", sortable: false },
        { text: "Importe", value: "", sortable: false, align: "right" },
        { text: "", value: "", sortable: false },
      ],
    };
  },
  computed: {
    filtered() {
      let items = this.matches;
      if (this.filter === "auto") items = items.filter((m) => m.type === "AUTO");
      if (this.filter === "manual") items = items.filter((m) => m.type !== "AUTO");
      const q = (this.search || "").trim().toLowerCase();
      if (!q) return items;
      return items.filter((m) => {
        const texts = [];
        m.details.forEach((d) => texts.push(d.tipo, d.comprobante, d.tercero, d.description, String(d.amount), formatUtils.formatNumber(d.amount)));
        m.lineas.forEach((l) => texts.push(l.concept, l.reference, String(l.amount), formatUtils.formatNumber(l.amount)));
        return texts.some((t) => t && String(t).toLowerCase().includes(q));
      });
    },
  },
  methods: {
    typeLabel(item) {
      if (item.type === "AUTO") return "Auto · fecha-monto";
      if (item.type === "CREADO") return "Creado desde banco";
      return "Manual · " + item.details.length + " → " + item.lineas.length;
    },
    // Hint del chip: tipo + quién y cuándo (los automáticos los genera el sistema)
    typeHint(item) {
      let hint = this.typeLabel(item);
      if (item.type !== "AUTO" && item.created_at) {
        const [date, time] = item.created_at.split(" ");
        hint += " · por " + (item.user || "-") + " el " + formatUtils.formatDateString(date) + (time ? " " + time.substr(0, 5) : "");
      }
      return hint;
    },
    typeShortLabel(item) {
      return { AUTO: "Auto", MANUAL: "Manual", CREADO: "Creado" }[item.type] || item.type;
    },
    typeIcon(type) {
      return { AUTO: "bolt", CREADO: "add_circle", MANUAL: "pan_tool" }[type];
    },
    typeColor(type) {
      return { AUTO: "blue lighten-5", CREADO: "purple lighten-5", MANUAL: "green lighten-5" }[type];
    },
    typeTextColor(type) {
      return { AUTO: "blue darken-3", CREADO: "purple darken-2", MANUAL: "green darken-3" }[type];
    },
  },
};
</script>

<style scoped>
.search {
  max-width: 420px;
}
.cell-list {
  vertical-align: middle;
}
.cell-row {
  min-height: 44px;
  padding: 4px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.cell-row + .cell-row {
  border-top: 1px dashed #d6dde5;
}
.date-col,
.amount-col {
  white-space: nowrap;
}
.reference {
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.syscore-mov,
.bank-mov {
  width: 25%;
}
.action-col {
  width: 36px;
  padding: 0 2px !important;
}
.gap.gap-mid {
  width: 80px;
  min-width: 80px;
}
.gap-sm {
  padding: 0 !important;
  width: 12px !important;
  min-width: 12px !important;
  padding: 0 !important;
}

/* Dos cajas (Syscore / Banco) con las filas alineadas: misma fila de tabla, celdas con fondo y borde propio */
.conciliados >>> table {
  border-collapse: separate;
  border-spacing: 0;
}
.conciliados >>> tbody tr:hover {
  background: transparent !important;
}
.conciliados >>> tbody tr:hover td.sc {
  background: #e8f1fd;
}
.conciliados >>> tbody tr:hover td.bk {
  background: #e7f4e8;
}
.sc {
  background: #f4f8fd;
}
.bk {
  background: #f3f9f3;
}
.sc-first {
  border-left: 1px solid #c5d8f0;
}
.sc-last {
  border-right: 1px solid #c5d8f0;
}
.bk-first {
  border-left: 1px solid #c8e2c9;
}
.bk-last {
  border-right: 1px solid #c8e2c9;
}
.conciliados >>> tbody td.sc {
  border-bottom: 1px solid #c5d8f0 !important;
}
.conciliados >>> tbody td.bk {
  border-bottom: 1px solid #c8e2c9 !important;
}
.gap {
  padding: 0 !important;
  width: 24px;
  min-width: 24px;
  background: #fff;
  border-bottom: none !important;
}
.group-row th.box-title {
  font-size: 13px !important;
  font-weight: 600;
  color: #37474f !important;
  height: 40px !important;
}
.group-row th.sc {
  background: #e3eefb;
  border-top: 1px solid #c5d8f0;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.group-row th.bk {
  background: #e2f1e3;
  border-top: 1px solid #c8e2c9;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.col-row th.sc {
  background: #eaf2fc;
  border-bottom: 1px solid #c5d8f0 !important;
}
.col-row th.bk {
  background: #e9f5ea;
  border-bottom: 1px solid #c8e2c9 !important;
}
.group-row th:not(.sc):not(.bk),
.col-row th.gap {
  border-bottom: none !important;
}
</style>
